import Vue from "vue";

Vue.mixin({
  methods: {
    tableHeaderStyle({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      const color = '#0f4c82'
      if (typeof row != "undefined" && rowIndex == 0 && columnIndex == 0) {
        return `background-color: #E2F6FF;color:${color};border: 1px solid #E5E5E5;border-top-left-radius: 8px;`;
      }

      if (
        typeof row != "undefined" &&
        rowIndex == 0 &&
        columnIndex == row.length - 1
      ) {
        return `background-color: #E2F6FF;color:${color};border: 1px solid #E5E5E5;border-top-right-radius: 8px;`;
      }

      return `background-color: #E2F6FF;color:${color};border: 1px solid #E5E5E5`;
    },
    indexMethod(index, page, pageSize) {
      return index + 1 + (page - 1) * pageSize;
    }
  },

});